import { staticColors } from '../../../const/colors/staticColors';
import { sizes } from '../../../const/sizes';
export const navigationVerticalItemShadow = `${sizes.navigationVerticalItem.boxShadowOffsetX} ${sizes.navigationVerticalItem.boxShadowOffsetY} ${sizes.navigationVerticalItem.boxShadowBlurRadius} ${staticColors.baseShadow}`;
